import 'lib/localizedMoment'

import React, {useState} from 'react'
import {v4 as uuidV4} from 'uuid'
import ReactDOM from 'react-dom'
import {ConfigProvider} from 'antd'
import nbNO from 'antd/lib/locale-provider/nb_NO'
import {ApolloProvider} from 'react-apollo'
import {BrowserRouter} from 'react-router-dom'
import TagManager from '@sooro-io/react-gtm-module'

import {client} from 'shared/lib/graphql'
import createRaygunErrorReporter from 'shared/lib/errorReporterRaygun'
import ErrorHandler from 'shared/components/ErrorHandler'
import AppWithAuth from 'shared/components/AppWithAuth'
import AuthenticatedApolloProvider from 'shared/components/AuthenticatedApolloProvider'
import RequestContext from 'shared/components/RequestContext'
import UserContext from 'shared/components/UserContext'
import VersionNotification from 'shared/components/VersionNotification'
import useVersionCheck from 'shared/hooks/useVersionCheck'

import {PrivateRoutes, Login, Sharing} from 'components'
import {GoogleAnalytics} from 'components/shared/GoogleAnalytics'
import config from 'lib/config'

import './index.scss'

import './i18n'

const audience = 'meglerapp'
const sessionId = uuidV4()

const publicApolloClient = client({uriPath: '/public', audience, sessionId})

if (config.GTM_ID) {
  TagManager.initialize({ gtmId: config.GTM_ID })
}

const SharingRoute = (props: any) => (
  <ConfigProvider locale={nbNO}>
    <ApolloProvider client={publicApolloClient}>
      <Sharing {...props} />
    </ApolloProvider>
  </ConfigProvider>
)

function App() {
  const [user, setUser] = useState({id: null, email: null})
  const { customFetch, hasNewVersion } = useVersionCheck()

  const errorReporter = createRaygunErrorReporter(user)

  return (
    <RequestContext.Provider value={{audience, sessionId}}>
      <UserContext.Provider value={user}>
        <ErrorHandler
          reporter={errorReporter}
          sessionId={sessionId}
          user={user}
        >
          <BrowserRouter>
            <GoogleAnalytics>
              <AppWithAuth
                options={{
                  jwtAud: audience,
                  jwtKey: 'inviso-megler-jwt',
                }}
                components={{
                  Login,
                }}
                publicRoutes={[
                  { path: '/deling/:sharingId', component: SharingRoute }
                ]}
              >
                <ConfigProvider locale={nbNO}>
                  <VersionNotification display={hasNewVersion} />
                  <AuthenticatedApolloProvider customFetch={customFetch}>
                    <PrivateRoutes user={user} setUser={setUser} />
                  </AuthenticatedApolloProvider>
                </ConfigProvider>
              </AppWithAuth>
            </GoogleAnalytics>
          </BrowserRouter>
        </ErrorHandler>
      </UserContext.Provider>
    </RequestContext.Provider>
  )
}

ReactDOM.render(<App />, document.getElementById('root'))
